class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Get accordion elements
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const accordionItems = this.querySelectorAll(".m-accordion--item");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");
    
    // Open all accordion items by default on mobile
    if (window.innerWidth <= 767) {
      this._openAllMenus();
    }
    
    // Set up click handlers for accordion buttons
    this._initAccordionHandlers();

    // Initialize accordion for mobile view
    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        // On mobile, expand all sub-menus by default
        this._openAllMenus();
      }
      
      document.addEventListener("matchMobile", () => {
        // When switching to mobile, expand all sub-menus
        this._openAllMenus();
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
    
    // Hook into window resize to handle mobile/desktop transitions
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 767) {
        // When resizing to mobile, ensure menus are expanded
        this._openAllMenus();
      }
    });
  }
  
  _openAllMenus() {
    // Force ALL menu items to be open on mobile
    const allAccordionItems = this.querySelectorAll('.m-accordion--item');
    
    allAccordionItems.forEach(item => {
      // Add the open class
      item.classList.add('open');
      
      // Find the content section and show it
      const content = item.querySelector('.m-accordion--item-content');
      if (content) {
        content.style.maxHeight = 'none';
        content.style.opacity = '1';
        content.style.display = 'block';
        content.setAttribute('aria-hidden', 'false');
      }
      
      // Rotate the arrow
      const arrow = item.querySelector('.m-accordion--item-icon');
      if (arrow) {
        arrow.style.transform = 'rotate(180deg)';
      }
    });
  }
  
  _initAccordionHandlers() {
    // Find all accordion buttons - in this case, we don't want a toggle behavior
    // We only want to allow closing open menus, not reopening
    const accordionButtons = this.querySelectorAll('.m-accordion--item-button');
    
    accordionButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        // Only handle on mobile
        if (window.innerWidth <= 767) {
          e.preventDefault();
          
          // Find parent accordion item
          const accordionItem = button.closest('.m-accordion--item');
          if (!accordionItem) return;
          
          // Find the content to toggle
          const content = accordionItem.querySelector('.m-accordion--item-content');
          if (!content) return;
          
          // Toggle the open state, but all items start open
          if (accordionItem.classList.contains('open')) {
            // Close it
            accordionItem.classList.remove('open');
            content.style.maxHeight = '0';
            content.style.opacity = '0';
            content.setAttribute('aria-hidden', 'true');
            
            // Rotate the arrow back
            const arrow = button.querySelector('.m-accordion--item-icon');
            if (arrow) {
              arrow.style.transform = 'rotate(0deg)';
            }
          } else {
            // Reopen it
            accordionItem.classList.add('open');
            content.style.maxHeight = 'none';
            content.style.opacity = '1';
            content.setAttribute('aria-hidden', 'false');
            
            // Rotate the arrow
            const arrow = button.querySelector('.m-accordion--item-icon');
            if (arrow) {
              arrow.style.transform = 'rotate(180deg)';
            }
          }
        }
      });
    });
  }
}

customElements.define("m-footer", MFooter);